// src/data/translations.js
 
const translations = {
  nl: {
    phishing: 'Fout',
    safe: 'Goed',
    scoreboard: 'Scorebord',
    selectLanguage: 'Selecteer taal',
    footer: 'Train je oog, blijf veilig.',
    nicknameTitle: 'Welkom bij Swishing',
    nicknameSubtitle: 'Train je oog. Herken de valse mails. Klim in het klassement.',
    chooseName: 'Kies je naam',
    namePlaceholder: 'Naam of bijnaam',
    nicknameButton: 'Start met trainen',
    nicknameErrorEmpty: 'Voer een naam in.',
    nicknameErrorExists: 'Naam is al in gebruik. Kies een andere.',
    allSwipesDone: 'Alle swipes voltooid!',
    popupScored: 'Jouw score is',
    viewScoreboard: 'Bekijk scorebord',
    scoreboardTitle: '🏆 Swishing Scorebord',
    scoreboardSubtitle: 'Zie hoe je presteert ten opzichte van anderen. Train hard en bereik de top!',
    rank: '#',
    name: 'Naam',
    score: 'Score',
    date: 'Datum',
 
    // NEW (already used in UI / nice to have)
    phishingReasonTitle: 'Oeps! Dit was een phishingmail.',
    phishingReasonDesc: 'Wees voorzichtig en controleer verdachte afzenders of links altijd extra goed.',
    continueButton: 'Doorgaan',
 
    lastSwipeTitle: 'Laatste uitdaging',
    lastSwipeBody: 'Hebben meerdere spelers dezelfde score? Dan bepaalt de snelheid van je laatste swipe wie hoger eindigt.',
    startNow: 'Start',
 
    tourSwipe: 'Swipe naar links als je denkt dat de e-mail phishing is, of naar rechts als je denkt dat deze legitiem is.',
    tourButtons: 'Je kunt desgewenst ook de knoppen gebruiken.',
    tourScoreDisplay: 'Je huidige score wordt hier weergegeven.',
 
    // NEW keys your component can use (fallbacks exist today)
    noMoreEmails: 'Geen e-mails meer!',
    welcomeTitle: 'Welkom!',
    welcomePlayingAs: 'Je speelt vandaag als:',
    welcomePrivacy: 'Deze anonieme naam beschermt je privacy op het scorebord!',
    welcomeStartCTA: 'Start het spel!',
    missedLegit: '❌ Oeps. Dit was een legitieme e-mail',

    time: '⏱ Tijd (laatste swipe)',
    yourRanking: 'Jouw ranking',

    // NL additions
welcomeShort: 'Welkom bij Swishing!',
nicknameGenerated: 'We hebben een anonieme naam voor je gegenereerd',
generatedNameLabel: 'Jouw anonieme naam:',
generating: 'Genereren...',
loading: 'Laden...',
newName: 'Nieuwe naam',
accept: 'Accepteren',
anonymityNote: 'Deze naam zorgt voor volledige anonimiteit op het scorebord',
generateError: 'Naam genereren mislukt. Probeer het opnieuw.',
  },
 
  en: {
    phishing: 'Wrong',
    safe: 'Correct',
    scoreboard: 'Scoreboard',
    selectLanguage: 'Select language',
    footer: 'Train your eye, stay secure.',
    nicknameTitle: 'Welcome to Swishing',
    nicknameSubtitle: 'Train your eye. Spot the fake emails. Climb the leaderboard.',
    chooseName: 'Choose your name',
    namePlaceholder: 'Name or nickname',
    nicknameButton: 'Start Training',
    nicknameErrorEmpty: 'Please enter a nickname.',
    nicknameErrorExists: 'Nickname is already used. Please choose another.',
    allSwipesDone: 'All swipes done!',
    popupScored: 'You scored',
    viewScoreboard: 'View Scoreboard',
    scoreboardTitle: '🏆 Swishing Scoreboard',
    scoreboardSubtitle: 'See how you rank among others. Train hard and reach the top!',
    rank: '#',
    name: 'Name',
    score: 'Score',
    date: 'Date',
 
    // NEW
    phishingReasonTitle: 'Oops! This was a phishing email.',
    phishingReasonDesc: 'Always double-check suspicious links or unexpected senders.',
    continueButton: 'Continue',
 
    lastSwipeTitle: 'Final challenge',
    lastSwipeBody: 'If multiple players have the same score, the speed of your final swipe decides who comes out on top.',
    startNow: 'Start',
 
    tourSwipe: 'Swipe left if you believe the email is phishing, or right if you believe it is legitimate.',
    tourButtons: 'You can also use the buttons if you prefer.',
    tourScoreDisplay: 'Your current score is shown here.',
 
    // NEW keys your component can use (fallbacks exist today)
    noMoreEmails: 'No more emails!',
    welcomeTitle: 'Welcome!',
    welcomePlayingAs: "You're playing today as:",
    welcomePrivacy: 'This anonymous name protects your privacy on the scoreboard!',
    welcomeStartCTA: 'Start the game!',
    missedLegit: '❌ Oops. This was a legitimate email',

    time: '⏱ Time (last swipe)',
    yourRanking: 'Your ranking',

    welcomeShort: 'Welcome to Swishing!',
nicknameGenerated: "We've generated an anonymous name for you",
generatedNameLabel: 'Your anonymous name:',
generating: 'Generating...',
loading: 'Loading...',
newName: 'New name',
accept: 'Accept',
anonymityNote: 'This name ensures complete anonymity on the scoreboard',
generateError: 'Failed to generate name. Please try again.',
  },
 
  fr: {
    phishing: 'Faux',
    safe: 'Correct',
    scoreboard: 'Classement',
    selectLanguage: 'Choisissez la langue',
    footer: 'Entraînez votre œil, restez en sécurité.',
    nicknameTitle: 'Bienvenue sur Swishing',
    nicknameSubtitle: 'Entraînez votre œil. Identifiez les faux e-mails. Montez dans le classement.',
    chooseName: 'Choisissez votre nom',
    namePlaceholder: 'Nom ou pseudonyme',
    nicknameButton: "Commencer l’entraînement",
    nicknameErrorEmpty: 'Veuillez saisir un nom.',
    nicknameErrorExists: 'Ce nom est déjà utilisé. Veuillez en choisir un autre.',
    allSwipesDone: 'Tous les swipes sont terminés !',
    popupScored: 'Votre score est',
    viewScoreboard: 'Voir le classement',
    scoreboardTitle: '🏆 Classement Swishing',
    scoreboardSubtitle: 'Voyez votre position par rapport aux autres. Entraînez-vous et atteignez le sommet !',
    rank: '#',
    name: 'Nom',
    score: 'Score',
    date: 'Date',
 
    // NEW
    phishingReasonTitle: 'Oups ! Cet e-mail était du phishing.',
    phishingReasonDesc: 'Soyez prudent et vérifiez toujours les expéditeurs ou liens suspects.',
    continueButton: 'Continuer',
 
    lastSwipeTitle: 'Dernier défi',
    lastSwipeBody: 'Si plusieurs joueurs ont le même score, la vitesse de votre dernier swipe déterminera qui passe devant.',
    startNow: 'Commencer',
 
    tourSwipe: "Swipez à gauche si vous pensez que l’e-mail est du phishing, à droite s’il est légitime.",
    tourButtons: 'Vous pouvez aussi utiliser les boutons si vous préférez.',
    tourScoreDisplay: 'Votre score actuel s’affiche ici.',
 
    // Keys used/fallbacks in your UI
    noMoreEmails: 'Plus d’e-mails !',
    welcomeTitle: 'Bienvenue !',
    welcomePlayingAs: 'Vous jouez aujourd’hui en tant que :',
    welcomePrivacy: 'Ce nom anonyme protège votre vie privée sur le classement !',
    welcomeStartCTA: 'Lancer le jeu !',
    missedLegit: '❌ Oups. Cet e-mail était légitime',

    time: '⏱ Temps (dernier swipe)',
yourRanking: 'Votre classement',

welcomeShort: 'Bienvenue sur Swishing !',
nicknameGenerated: 'Nous avons généré un nom anonyme pour vous',
generatedNameLabel: 'Votre nom anonyme :',
generating: 'Génération…',
loading: 'Chargement…',
newName: 'Nouveau nom',
accept: 'Accepter',
anonymityNote: 'Ce nom garantit votre anonymat complet sur le classement',
generateError: 'Échec de la génération du nom. Veuillez réessayer.',
  },
};
 
export default translations;